import * as React from "react";
import { SVGProps } from "react";

const Derivadao = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 472 168" {...props}>
    <path
      fill="#2d1680"
      d="M0 0h72c42 0 76 34 76 76H0V0zm163 0h72c42 0 76 34 76 76H163V0zM0 168h72c42 0 76-34 76-76H0v76zm163 0h72c42 0 76-34 76-76H163v76zM305 0h53.3L472 168h-56.3L305 0z"
    />
    <path
      fill="#ef88aa"
      stroke="#ef88aa"
      strokeDasharray="229.2358,245.7249"
      strokeWidth={3}
      d="m424.5 66-44-64.5h89l-45 64.5z"
      opacity={0.933}
    />
    <path
      fill="#ef88aa"
      stroke="#ef88aa"
      strokeDasharray="220.3232,236.1712"
      strokeWidth={5}
      d="m350 103-43.5 62.5h85L350 103z"
      opacity={0.933}
    />
  </svg>
);

export default Derivadao;
